/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AffiliateDto
 */
export interface AffiliateDto {
    /**
     * 
     * @type {string}
     * @memberof AffiliateDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AffiliateDto
     */
    code: string;
    /**
     * 
     * @type {number}
     * @memberof AffiliateDto
     */
    rate: number;
    /**
     * 
     * @type {string}
     * @memberof AffiliateDto
     */
    userId: string;
    /**
     * 
     * @type {Date}
     * @memberof AffiliateDto
     */
    lastUpdated: Date;
}

export function AffiliateDtoFromJSON(json: any): AffiliateDto {
    return AffiliateDtoFromJSONTyped(json, false);
}

export function AffiliateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AffiliateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'rate': json['rate'],
        'userId': json['userId'],
        'lastUpdated': (new Date(json['lastUpdated'])),
    };
}

export function AffiliateDtoToJSON(value?: AffiliateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'rate': value.rate,
        'userId': value.userId,
        'lastUpdated': (value.lastUpdated.toISOString()),
    };
}

